var React = require('react');

function HelpFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.6,2.3c-3.1-3.1-8.2-3.1-11.3,0s-3.1,8.2,0,11.3C3.9,15.2,6,16,8,16s4.1-0.8,5.7-2.3C16.7,10.5,16.7,5.5,13.6,2.3z\n\t M8,12.3c-0.6,0-1-0.4-1-0.9c0-0.6,0.4-0.9,1-0.9s0.9,0.3,0.9,0.9C8.8,11.9,8.5,12.3,8,12.3z M9.4,7.9C8.7,8.3,8.5,8.6,8.5,9.2v0.3\n\tH7.2V9.1c0-0.9,0.3-1.3,1.1-1.8c0.7-0.4,1-0.7,1-1.3S8.7,4.9,8,4.9c-0.7,0-1.3,0.5-1.4,1.2H5.4c0.1-1.4,1-2.4,2.7-2.4\n\tc1.6,0,2.6,0.9,2.6,2.2C10.6,6.8,10.2,7.4,9.4,7.9z","fill":"currentColor"}));
}

HelpFilled.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = HelpFilled;

HelpFilled.default = HelpFilled;
